// Custom global scripts
jQuery(document).ready(
  (function ($) {
    "use strict";

    // Foundation Init
    $(document).foundation();

    $(".menu-item a").click(function (e) {
      if (window.location.pathname.includes($(this)[0].pathname)) {
        //properly scroll to portfolio section
        if (
          $(this)
            .attr("href")
            .includes("#panel-")
        ) {
          e.preventDefault();
          let pos = $("#portfolio").offset().top - 80;
          $("html,body").animate({ scrollTop: pos }, 1500);
        }
      }
    });

    // Mobile nav toggle
    $("#nav-mobile-toggle").on("click", function () {
      $("#nav-mobile").slideToggle();
    });

    // nav search toggle
    $("#nav-search-toggle").on("click", function () {
      $(".search-field").value = "";
      $(".search-form-wrap").toggle();
      $("#nav-main").toggle();
      $("#button-support").addClass("hide");
      $(this).toggleClass("fa-search");
    });

    // nav search close
    $(".search-form__close").on("click", function () {
      $(".search-form-wrap").toggle();
      $("#nav-main").toggle();
      $("#button-support").removeClass("hide");
      $("#nav-search-toggle").toggleClass("fa-search");
    });

    //smooth scroll
    $("a[href^='#']:not(.resource-tab)").click(function (e) {
      e.preventDefault();

      var targetId = $(this).attr("href");
      var $targetElement = $(targetId);
  
      if (targetId && $(targetId).length) {
        var position = $(targetId).offset().top;

        $("body, html").animate(
            {
                scrollTop: position
            },
            500,
            "linear"
        );
      }
    });
  })(jQuery)
);

//Homepage Image text flip

var aboutimageOne = document.getElementById('about-image-one')
var aboutimageOneText = document.getElementById('about-image-one-text');
var aboutimageTwo = document.getElementById('about-image-two')
var aboutimageTwoText = document.getElementById('about-image-two-text');
var aboutimageThree = document.getElementById('about-image-three')
var aboutimageThreeText = document.getElementById('about-image-three-text');
var aboutimageFour = document.getElementById('about-image-four')
var aboutimageFourText = document.getElementById('about-image-four-text');

if (aboutimageOne) {
  aboutimageOne.addEventListener('click', function () {
    aboutimageOneText.classList.toggle("textOpen");
  })
}
if (aboutimageTwo) {
  aboutimageTwo.addEventListener('click', function () {
    aboutimageTwoText.classList.toggle("textOpen");
  })
}
if (aboutimageThree) {
  aboutimageThree.addEventListener('click', function () {
    aboutimageThreeText.classList.toggle("textOpen");
  })
}
if (aboutimageFour) {
  aboutimageFour.addEventListener('click', function () {
    aboutimageFourText.classList.toggle("textOpen");
  })
}
// var textBox = document.querySelectorAll('.about-image-text-container');
// imageBox.addEventListener('click', function () {
//   console.log('sff')
//   textBox.classList.add("textOpen");
// })


//HOmepage Service Scroll
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname == '/') {
    window.onscroll = function () { myFunction() };
    const homeServices = document.getElementById('homepage-services-cards')
    function myFunction() {  
      if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 400) {
        if(homeServices) {
          homeServices.classList.add('hover');
        }
       
      } else {
        if(homeServices) {
          homeServices.classList.remove('hover');
        }
      }
      // if (document.body.scrollTop < 350 || document.documentElement.scrollTop < 350) {
      //   homeServices.classList.remove('hover');
      // }
      if (document.body.scrollTop > 1150 || document.documentElement.scrollTop > 1150) {
        if(homeServices) {
          homeServices.classList.remove('hover');
        }
      }
    }
  }
});
